import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { PurchaseRequisitionActionTypes } from "./PurchaseRequisition.type";

export function* fetchAllPurchaseRequisitions(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/purchase-requisition`);
    yield put({
      type: PurchaseRequisitionActionTypes.FETCH_ALL_PURCHASE_REQUISITION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: PurchaseRequisitionActionTypes.FETCH_ALL_PURCHASE_REQUISITION_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOnePurchaseRequisitions(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/purchase-requisition/${action.payload}`
    );
    yield put({
      type: PurchaseRequisitionActionTypes.FETCH_ONE_PURCHASE_REQUISITION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: PurchaseRequisitionActionTypes.FETCH_ONE_PURCHASE_REQUISITION_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllPurchaseRequisitions() {
  yield takeLatest(
    PurchaseRequisitionActionTypes.FETCH_ALL_PURCHASE_REQUISITION,
    fetchAllPurchaseRequisitions
  );
}

export function* watcherFetchOnePurchaseRequisitions() {
  yield takeLatest(
    PurchaseRequisitionActionTypes.FETCH_ONE_PURCHASE_REQUISITION,
    fetchOnePurchaseRequisitions
  );
}
